import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0141ac",
    },
    secondary: {
      main: "#4dabff",
    },
    error: {
      main: "#f44336",
    },
    warning: {
      main: "#ff9800",
    },
    success: {
      main: "#4caf50",
    },
    background: {
      main: "#f3f5fb",
    },
  },

  typography: {
    fontFamily: "sans-serif",
    decoration: {
      textDecoration: "underline",
      textDecorationColor: "#3f51b5",
    },
    h1: {
      fontSize: "1.8rem",
      fontWeight: 400,
    },
    h2: {
      fontSize: "1.1rem",
      fontWeight: 550,
    },
    h3: {
      fontSize: "1.1rem",
      fontWeight: 400,
    },
    h4: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: "0.8rem",
      fontWeight: 300,
    },
    body1: {
      fonstSize: "0.6rem",
    },
    b2: {
      fontSize: "1rem",
    },
  },
});

export default theme;
